/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailableKpisResult } from '../../models/available-kpis-result';

export interface GetAvailableKpiIdentifiers$Params {
  workCenterId: number;
}

export function getAvailableKpiIdentifiers(http: HttpClient, rootUrl: string, params: GetAvailableKpiIdentifiers$Params, context?: HttpContext): Observable<StrictHttpResponse<AvailableKpisResult>> {
  const rb = new RequestBuilder(rootUrl, getAvailableKpiIdentifiers.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AvailableKpisResult>;
    })
  );
}

getAvailableKpiIdentifiers.PATH = '/api/v1/WorkCenter/{workCenterId}/AvailableKpis';
